import { DataParam, Dimension } from '@gspwidget/util';
import { PropertyOption } from '@gspwidget/widget-devkit';

export interface PropertyChangeEvent { propName: string; value: any; }
export interface PropsAndValues {
  props: PropertyOption[];
  /** 传入 config editor 时，pv 跟 props 不一定非要一一对应，哪个多点少点都能正常用 */
  propValues: object;
}

export interface CEExtra {
  cols?: Dimension[]
  data?: any
  dataParams?: DataParam[]
}
export interface CEContext {
  extra?: CEExtra
}

export interface I18nDataField {
  name: string
  label: string
  // string 是为了准备用户手写字段直接给 name 值
  i18nLabel: any | string
}

export interface CEDF {
  name: string
  label: any | string
}
